import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CouponLandingPageService_GetCategoryNavigationLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/landingpage/service.grpc.lazy';
import {useParams} from '@aboutyou/router';
import {useFullSession} from '@aboutyou/user';
import {useAnyFilterFlyoutOpened} from '../../../features/Filters/shared/useAnyFilterFlyoutOpened';
import {useAppliedPotentialFilters} from '../../../features/ProductStream/utils';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useCategoryIdentifier} from '../hooks/useCategoryIdentifier';

export const useCouponLandingPageCategoryNavigation = () => {
  const appliedFilters = useAppliedPotentialFilters();
  const isFilterFlyoutOpen = useAnyFilterFlyoutOpened();
  const targetGroup = useTargetGroupIdentifier();
  const session = useFullSession();
  const {promotionId} = useParams();
  const categoryIdentifier = useCategoryIdentifier();

  return useGrpcRequest(
    CouponLandingPageService_GetCategoryNavigationLazy,
    {
      appliedFilters: {
        filters: appliedFilters,
      },
      category: categoryIdentifier,
      reductionsState: useReductionsStateRequestParameter(),
      targetGroup,
      session: session!,
      couponPromotionId: promotionId || '',
    },
    {
      disabled: isFilterFlyoutOpen || !session || !promotionId,
      keepPreviousData: true,
    },
  );
};
